import { gql } from '@apollo/client';
import {WarehouseSiteType} from "../../enums/WarehouseTypeEnum";

export const GET_EXCEPTION_DICTIONARY_BY_WAREHOUSE_TYPE = gql`
    query GetExceptionDictionaryByWarehouseType($warehouseSiteType: WarehouseSiteType!) {
        getExceptionsDictionaryByWarehouseType(warehouseSiteType: $warehouseSiteType) {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionSubReasonType {
    code: string;
    textZh: string;
    textEn: string;
    textEs: string;
}

export interface ExceptionDictionaryListResponse {
    getExceptionsDictionaryByWarehouseType: ExceptionDictionaryType[];
}

export interface ExceptionDictionaryType {
    exceptionReasonCode: string;
    primaryType: string;
    secondaryTypeZh: string;
    secondaryTypeEn: string;
    secondaryTypeEs?: string;
    isUploadsImages: boolean;
    exceptionSubReasons?: ExceptionSubReasonType[];  // 二级原因列表（包含国际化信息）
}



export const GET_EXCEPTION_DICTIONARY_BY_REASON_CODE = gql`
    query ExceptionDictionaryQuery($exceptionReasonCode: String!) {
        getExceptionDictionaryByReasonCode(exceptionReasonCode: $exceptionReasonCode) {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionDictionaryByCodeResponse {
    getExceptionDictionaryByReasonCode: ExceptionDictionaryType;
}

export const GET_EXCEPTION_DICTIONARY_FOR_WHS = gql`
    query GetExceptionDictionaryForWHS {
        getExceptionDictionaryForWHS {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionDictionaryForWhsResponse {
    getExceptionDictionaryForWHS: ExceptionDictionaryType[];
}